export { ReactComponent as ArrowIcon } from "./ArrowIcon.svg";
export { ReactComponent as ElevatorIcon } from "./ElevatorIcon.svg";
export { ReactComponent as StairIcon } from "./StairIcon.svg";